import Vue from "vue";
import Router from "vue-router";
import Dashboard from "./views/Dashboard.vue";
import UserProfileLite from "./views/UserProfileLite.vue";
import AddNewTier from "./views/AddNewTier.vue";
import AddNewAction from "./views/AddNewAction.vue";
import Errors from "./views/Errors.vue";
import ComponentsOverview from "./views/ComponentsOverview.vue";
import supporters from "./views/Members.vue";
import SentVideos from "./views/SentVideos.vue";
import Setup from "./views/Setup.vue";
import Contacts from "./views/Contacts.vue";
import Onboard from "./views/Onboard.vue";
import Todos from "./views/Todos.vue";
import LinkBuilder from "./views/LinkBuilder.vue";
import Login from "./views/LoginPage.vue";
import Register from "./views/Register.vue";
import Downloads from "./views/Downloads.vue";
import Billing from "./views/Billing.vue";
import store from "./vuex/store";
import Callback from "./components/Callback.vue";
Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "active",
  linkExactActiveClass: "exact-active",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      redirect: "/dashboard",
      meta: { requiresAuth: true }
    },
    {
      path: "/callback",
      name: "callback",
      component: Callback,
      meta: {
        requiredAuth: false,
        layout: "home"
      }
    },
    {
      path: "/register",
      name: "register",
      component: Register,
      meta: { requiresAuth: false, layout: "home" }
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: { requiresAuth: false, layout: "home" }
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard,
      meta: { requiresAuth: true }
    },
    {
      path: "/billing",
      name: "billing",
      component: Billing,
      meta: { requiresAuth: true }
    },
    {
      path: "/user-profile-lite",
      name: "user-profile-lite",
      component: UserProfileLite,
      meta: { requiresAuth: true }
    },
    {
      path: "/tiers",
      name: "tiers",
      component: AddNewTier,
      meta: { requiresAuth: true }
    },
    {
      path: "/onboard",
      name: "onboard",
      component: Onboard,
      meta: { requiresAuth: true }
    },
    {
      path: "/todos",
      name: "todos",
      component: Todos,
      meta: { requiresAuth: true }
    },
    {
      path: "/ctas",
      name: "ctas",
      component: AddNewAction,
      meta: { requiresAuth: true }
    },
    {
      path: "/errors",
      name: "errors",
      component: Errors,
      meta: { requiresAuth: true }
    },
    {
      path: "/link-builder",
      name: "link-builder",
      component: LinkBuilder,
      meta: { requiresAuth: true }
    },
    {
      path:
        "https://www.notion.so/givemagic/Givemagic-Help-Center-c0444d84c75848bc91519c902db14985",
      name: "support",
      meta: { requiresAuth: false }
    },
    {
      path: "/components-overview",
      name: "components-overview",
      component: ComponentsOverview,
      meta: { requiresAuth: true }
    },
    {
      path: "/setup",
      name: "setup",
      component: Setup,
      meta: { requiresAuth: true }
    },
    {
      path: "/upload",
      name: "Contacts",
      component: Contacts,
      meta: { requiresAuth: true }
    },
    {
      path: "/supporters",
      name: "supporters",
      component: supporters,
      meta: { requiresAuth: true }
    },
    {
      path: "/downloads",
      name: "downloads",
      component: Downloads,
      meta: { requiresAuth: true }
    },
    {
      path: "*",
      redirect: "/errors",
      meta: { requiresAuth: true }
    }
  ]
});

router.beforeEach((to, from, next) => {
  store.commit("checkAuth");
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.state.auth.isAuthenticated) {
      //store.dispatch("renewTokens");
      next();
      return;
    }
    next("/login");
  } else {
    next();
  }
});

export default router;
